// extracted by mini-css-extract-plugin
export default {"badge":"badge---s1z4W","substantive":"substantive---CAH6W","communication":"communication---hvX8R"};